var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKofi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.5 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1,1.1h143"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.5,21c-2.3,0-4.2-1-5.2-3.1c-1-1.9-1-3.8-1-5.8c0-1.3,0.4-2.3,1-3.1c0.6-0.8,1.5-1.3,2.5-1.5 c1-0.2,2.5-0.2,4-0.2c2.5,0,3.1,0,4,0.2c1.3,0.2,2.3,0.6,3.1,1.5s1.3,1.9,1.3,3.3v0.2c0,2.3-1.3,4-3.3,4.6c-0.2,0.4-0.4,0.6-0.6,1 l0,0c-0.6,1-2.3,2.9-5.2,2.9H71.5L71.5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.9,8.2C76,8.2,75.3,8,72.7,8c-1.5,0-3.1,0-4.2,0.2c-1.5,0.2-2.6,1.5-2.6,3.7s0,4,0.9,5.5 c0.9,1.8,2.6,2.9,4.6,2.9h0.4c2.6,0,4-1.5,4.6-2.6c0.2-0.4,0.4-1.1,0.7-1.5c1.8-0.2,3.1-1.8,3.1-3.7v-0.4 C80.4,9.7,79.1,8.4,76.9,8.2L76.9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M65.9,11.9c0-2.2,1.3-3.5,2.6-3.7C69.6,8,70.9,8,72.7,8c2.6,0,3.3,0,4.2,0.2c2.2,0.2,3.5,1.8,3.5,4v0.2 c0,2-1.3,3.5-3.1,3.7c-0.2,0.4-0.4,1.1-0.7,1.5c-0.7,1.1-2,2.6-4.6,2.6h-0.4c-2,0-3.7-0.9-4.6-2.9C65.9,15.9,65.9,14.1,65.9,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67,11.9c0,2.2,0.2,3.5,0.9,4.8c0.7,1.5,2.2,2.2,3.7,2.2H72c2,0,3.1-1.1,3.5-2c0.2-0.4,0.4-1.1,0.7-1.8v-0.4 h0.7c1.3,0,2.4-1.1,2.4-2.4v-0.4c0-1.5-0.9-2.4-2.4-2.6c-0.9,0-1.5-0.2-4-0.2c-1.8,0-2.9,0-4,0.2C67.4,9.5,67,10.4,67,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M76.2,13c0,0.2,0.2,0.4,0.4,0.4c0.9,0,1.3-0.4,1.3-1.3s-0.4-1.3-1.3-1.3c-0.2,0-0.4,0.2-0.4,0.4V13L76.2,13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A16",
    d: "M68.5,13c0,1.1,0.4,2,1.1,2.6c0.4,0.4,1.1,1,1.5,1.3c0.1,0.1,0.4,0.2,0.4,0.2s0.3-0.2,0.4-0.2 c0.4-0.3,1.1-0.9,1.5-1.3c0.7-0.7,1.1-1.5,1.1-2.6s-0.7-2-1.8-2c-0.7,0-1.1,0.4-1.3,0.9c-0.2-0.4-0.7-0.9-1.3-0.9 C69.2,10.8,68.5,11.9,68.5,13"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M38,1.7c20.4,0,22.9,0.8,22.9,14.3c0,7.3,4.7,12.3,12,12.3s12-5,12-12.3c0-13.5,2.8-14.2,22.9-14.2 C107.8,1.8,38,1.7,38,1.7z M72.9,24.1c-6,0-10.7-4.9-10.7-10.7c0-6,4.9-10.7,10.7-10.7s10.7,4.9,10.7,10.7S78.9,24.1,72.9,24.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKofi);
export default __webpack_public_path__ + "static/media/kofi.f3d10aa756e0d9668bd685b85358f9bf.svg";
export { ForwardRef as ReactComponent };